<template>
        <div class="flex flex-col h-full">
                <div class="bg-zinc-50 pb-10 h-full">
                        <header class="header fixed w-full z-50 p-2 bg-gradient-to-b from-black/50 to-transparent">
        <div class="container flex justify-between items-center">
            <!-- Header Logo -->
             <router-link :to="{ name: 'landing' }">
            <img class="coisar-logo-white h-6" alt="Coisar Logo" src="/coisar-logo-white.png">
            </router-link>
            <!-- Header Menu (visible only on md and up) -->
            <div class="menu bg-white flex-row items-center rounded-b-[2rem] gap-8 py-4 px-8 -mt-2 hidden md:flex">
                <nav class="flex items-center gap-4">
                    <router-link to="/landing#content">{{ $gettext("Features") }}</router-link>
                        <span class="separator text-xs">•</span>
                    <router-link to="/landing#pricing">{{ $gettext("Prices") }}</router-link>
                        <span class="separator text-xs">•</span>
                    <router-link to="/landing#faq">{{ $gettext("FAQ") }}</router-link>
                </nav>
                <Menu as="div" class="relative">
                    <MenuButton
                        class="bg-white hover:bg-gray-100 text-gray-900 px-4 py-2 rounded-md flex items-center gap-1"
                    >
                        <span :class="'fi fi-' + availableLanguages.find(lang => lang.code === applicationStore.currentLocale).flag"></span>
                    </MenuButton>
                    <MenuItems class="origin-top-right absolute right-0 mt-2 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none">
                        <MenuItem
                            v-for="lang in availableLanguages"
                            :key="lang.code"
                            @click="applicationStore.setCurrentLocale(lang.code)"
                            class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900"
                        >
                        <template>
                            <span :class="'fi fi-' + lang.flag"></span>                        </template>
                        </MenuItem>
                    </MenuItems>
                </Menu>
            </div>
            <!-- Hamburger Menu -->
            <button
              class="hamburger bg-white flex-row items-center rounded-bl-[2rem] p-4 pl-6 -mt-2 -mr-6 md:hidden order-3" @click="isMobileMenuOpen = !isMobileMenuOpen">
                <font-awesome-icon class="text-xl hover:text-indigo-200" :icon="['fasr', 'bars']" />
            </button>
            <nav v-if="isMobileMenuOpen" class="absolute top-full right-4 mt-2 bg-white rounded-xl shadow-lg py-2 px-4 z-40 md:hidden">
              <ul class="flex flex-col gap-2 text-end">
                <li><router-link to="/landing#content">{{ $gettext("Features") }}</router-link></li>
                <li><router-link to="/landing#pricing">{{ $gettext("Prices") }}</router-link></li>
                <li><router-link to="/landing#faq">{{ $gettext("FAQ") }}</router-link></li>
                <li v-for="lang in availableLanguages" :key="lang.code">
                        <button @click="applicationStore.setCurrentLocale(lang.code)">
                        <span :class="'fi fi-' + lang.flag"></span>                       
                        </button>
                </li>
              </ul>
            </nav>
            <!-- Header Button -->
            <router-link :to="{ name: 'login' }" class="btn-primary">Login</router-link>
        </div>
    </header>
                        <router-view></router-view>
                 
                        <footer class="bg-indigo-900 text-white px-8 pt-12 pb-6 text-sm">
                                <div class="max-w-screen-xl mx-auto grid grid-cols-1 md:grid-cols-4 gap-8">
                                        <!-- Logo & Slogan -->
                                        <div class="space-y-4">
                                                <img src="/coisar-logo-white.png" alt="Coisar Logo" class="h-6">
                                        </div>

                                        <!-- Services -->
                                        <div class="space-y-4">
                                                <h3 class="text-lg font-semibold">Unsere Dienste</h3>
                                                <ul class="space-y-2">
                                                        <li v-for="item in navigation.services" :key="item.name">
                                                                <a :href="item.href" target="_blank" class="hover:text-indigo-200">{{ item.name }}</a>
                                                        </li>
                                                </ul>
                                        </div>

                                        <!-- Knowledge -->
                                        <div class="space-y-4">
                                                <h3 class="text-lg font-semibold">Human Design</h3>
                                                <ul class="space-y-2">
                                                        <li v-for="item in navigation.knowledge" :key="item.name">
                                                                <a :href="item.href" class="hover:text-indigo-200">{{ item.name }}</a>
                                                        </li>
                                                </ul>
                                        </div>

                                        <!-- Contact & Legal -->
                                        <div class="space-y-4">
                                                <h3 class="text-lg font-semibold">Kontakt & Rechtliches</h3>
                                                <ul class="space-y-2">
                                                        <li v-for="item in navigation.support" :key="item.name">
                                                                <a :href="item.href" class="hover:text-indigo-200">{{ item.name }}</a>
                                                        </li>
                                                        <li v-for="item in navigation.legal" :key="item.name">
                                                                <router-link :to="item.href" class="hover:text-indigo-200">{{ item.name }}</router-link>
                                                        </li>
                                                </ul>
                                        </div>
                                </div>

                                <hr class="border-white my-8" />

                                <div class="max-w-screen-xl mx-auto flex flex-col md:flex-row justify-between items-center text-xs space-y-4 md:space-y-0">
                                        <p>© 2025 <strong>COISAR</strong> by Human Design Club. All rights reserved.</p>
                                        <div class="flex space-x-4">
                                                <a v-for="item in navigation.social" :key="item.name" :href="item.href" target="_blank" 
                                                   class="text-white hover:text-indigo-200" :title="item.name">
                                                        <font-awesome-icon :icon="item.icon" class="w-5 h-5" />
                                                        <span class="sr-only">{{ item.name }}</span>
                                                </a>
                                        </div>
                                </div>
                        </footer>
                        
                </div>





        </div>



</template>
<script setup>

import CoisarLogo from './../assets/icons/coisar-logo.svg'
import { ref } from 'vue';
import { useApplicationStore } from '/src/stores/application.js';
import { useStoryblok } from '@storyblok/vue';
import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/vue';
const applicationStore = useApplicationStore()

const story = await useStoryblok('global/footer', {
    version: 'draft'
});

const availableLanguages = [
        {
                code: 'de',
                flag: 'de',
        },
        {
                code: 'en',
                flag: 'gb',
        },
];


const isMobileMenuOpen = ref(false);

const navigation = {
        services: [
                { name: 'Human Design Club', href: 'https://humandesignclub.com' },
                { name: 'Human Design 24', href: 'https://humandesign24.de' },
                { name: 'Podcast', href: 'http://humandesignpodcast.de' },
                { name: 'Masterclass', href: 'https://humandesignmasterclass.de' },
        ],
        support: [
                { name: 'Kontakt', href: 'mailto:hello@coisar.com' },
        ],
        knowledge: [
                { name: 'Types', href: '#' },
                { name: 'Profile', href: '#' },
                { name: 'Gates', href: '#' },
                { name: 'Lines', href: '#' },
                { name: 'Talents', href: '#' },
        ],
        legal: [
                { name: 'Impressum', href: { name: 'legal', params: { type: 'imprint' } } },
                { name: 'Datenschutz', href: { name: 'legal', params: { type: 'privacy' } } },
                { name: 'AGB', href: { name: 'legal', params: { type: 'terms' } } },
        ],
        social: [
                {
                        name: 'Skool',
                        href: 'https://www.skool.com/humandesign',
                        icon: ['fak', 'skool'],
                },
                {
                        name: 'Instagram',
                        href: 'https://www.instagram.com/humandesignclub_de',
                        icon: ['fab', 'instagram'],
                },
                {
                        name: 'Facebook',
                        href: 'https://www.facebook.com/humandesignclub.de/',
                        icon: ['fab', 'facebook'],
                },
                {
                        name: 'Spotify',
                        href: 'https://open.spotify.com/show/54NagLee4OKFK2XjOInfI1',
                        icon: ['fab', 'spotify'],
                }, {
                        name: 'Youtube',
                        href: 'https://www.youtube.com/@humandesignclub',
                        icon: ['fab', 'youtube'],
                }

        ],
}

</script>